/* eslint-disable import/prefer-default-export */

import {
    RequestConfigFunction, InferParams, DataRequest,
} from 'app/types/request.types'

import requestBusinessObjects from './requestBusinessObjects'
import requestTable from './requestTable'
import requestMultiplePages from './requestMultiplePages'
import requestFunctionBuilder from './requestFunctionBuilder'
import responseParser from './responseParser'

type RequestFuncTableOptions = {
    withPagination?: boolean
}

const requestFuncTable = <
    RequestParams extends Record<string, any>,
    ResponseData = any
>(
        specRequestFn: RequestConfigFunction<RequestParams, ResponseData>,
        options?: RequestFuncTableOptions,
    ) => {
    return requestFunctionBuilder<ResponseData>({
        paramFn: (rest) => {
            const tempTest: Record<string, any> = {
                ...specRequestFn({
                    ...rest as InferParams<typeof specRequestFn>,
                }),
            }

            return {
                ...tempTest,
                data: {
                    rows: 50,
                    start: 0,
                    ...tempTest.data,
                },
            }
        },
        requestFn: options?.withPagination ? requestMultiplePages : requestTable,
        parserFn: responseParser.table,
    })
}
const requestFuncGetEntity = <
    RequestParams extends Record<string, any>,
    ResponseData = any
>(
        specRequestFn: RequestConfigFunction<RequestParams, ResponseData>,
        responseParserFn:
        (input: Promise<{ data: ResponseData }>) => Promise<any> = responseParser.entity,
    // eslint-disable-next-line max-len
        requestFn: (config: DataRequest) => Promise<{ data: ResponseData }> = requestBusinessObjects,
    ) => {
    return requestFunctionBuilder<ResponseData>({
        paramFn: (rest) => {
            return {
                method: 'GET',
                ...specRequestFn({
                    ...rest as InferParams<typeof specRequestFn>,
                }),
            }
        },
        requestFn,
        parserFn: responseParserFn,
    })
}

export const RequestFn = {
    table: requestFuncTable,
    getEntity: requestFuncGetEntity,
}
